import React from 'react';
import { Camera } from 'lucide-react';

const Avatar = ({ 
  size = 'md', 
  src, 
  initials, 
  color = '#6366f1',
  type = 'initials',
  onClick,
  showUploadButton = false,
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: 'w-16 h-16 text-lg',
    '2xl': 'w-20 h-20 text-xl'
  };

  const baseClasses = `
    inline-flex items-center justify-center rounded-full font-semibold
    ${sizeClasses[size]} ${className}
    ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}
  `;

  const content = () => {
    if (type === 'image' && src) {
      return (
        <img
          src={src}
          alt="Avatar"
          className="w-full h-full object-cover rounded-full"
        />
      );
    }
    
    // Default to initials
    return (
      <span className="text-white select-none">
        {initials || 'U'}
      </span>
    );
  };

  return (
    <div className="relative">
      <div
        className={baseClasses}
        style={{ backgroundColor: type === 'initials' ? color : undefined }}
        onClick={onClick}
      >
        {content()}
      </div>
      
      {showUploadButton && (
        <button
          className="absolute -bottom-1 -right-1 w-6 h-6 bg-gray-800 hover:bg-gray-700 rounded-full flex items-center justify-center border-2 border-white transition-colors"
          onClick={onClick}
        >
          <Camera className="w-3 h-3 text-white" />
        </button>
      )}
    </div>
  );
};

export default Avatar;
